import { Alert } from 'antd'

export default Confirmation = ({ confirmation }) ->

  <Alert
    showIcon
    message="Entity created successfully"
    description={confirmation}
    type="success"
  />